<template>
  <div>
    <TransitionRoot as="template" :show="openNewCompanyDrawer">
      <Dialog as="div" class="relative z-40" @close="openNewCompanyDrawer = false">
        <div class="fixed inset-0"/>
        <div class="fixed inset-0 overflow-hidden pt-60">
          <div class="absolute inset-0 overflow-hidden pt-60">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                <DialogPanel class="pointer-events-auto w-screen max-w-2xl">
                  <div class="flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle class="text-base font-semibold text-gray-900">{{ $gettext('Ajouter une organisation') }}</DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button type="button" class="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2" @click="openNewCompanyDrawer = false">
                            <span class="absolute -inset-2.5" />
                            <span class="sr-only">Close panel</span>
                            <XMarkIcon class="size-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-6 flex-1 px-4 sm:px-6">
                      <CompanyForm :company="company" @submit="onNewCompanySubmit" @cancel="onNewCompanyCancel" />
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
  <div>
    <TransitionRoot as="template" :show="openNewPhysicalPersonDrawer">
      <Dialog as="div" class="relative z-40" @close="openNewPhysicalPersonDrawer = false">
        <div class="fixed inset-0"/>
        <div class="fixed inset-0 overflow-hidden pt-60">
          <div class="absolute inset-0 overflow-hidden pt-60">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                <DialogPanel class="pointer-events-auto w-screen max-w-2xl">
                  <div class="flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle class="text-base font-semibold text-gray-900">{{ $gettext('Ajouter une personne physique') }}</DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button type="button" class="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2" @click="openNewPhysicalPersonDrawer = false">
                            <span class="absolute -inset-2.5" />
                            <span class="sr-only">Close panel</span>
                            <XMarkIcon class="size-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-6 flex-1 px-4 sm:px-6">
                      <PhysicalPersonForm :physical-person="physicalPerson" :ubo="isUBOField" @submit="onPhysicalPersonSubmit" @cancel="onPhysicalPersonCancel" />
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>

  <Combobox as="div" class="w-full sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2" v-model="currentCustomer" @update:modelValue="query = ''" :nullable="true">
    <div>
      <ComboboxLabel :for="fieldPath" class="block text-sm font-medium text-gray-900 sm:mt-2">
        {{ fieldLabel }}
      </ComboboxLabel>
    </div>
    <div class="sm:col-span-2">
      <div class="flex items-start gap-2">
        <div class="w-80">
          <div class="relative w-full">
            <ComboboxInput
              :id="fieldPath"
              :name="fieldPath"
              :placeholder="$gettext('Entrer votre recherche')"
              class="w-full block rounded-md bg-white py-1.5 pl-3 pr-10 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-indigo-600 sm:text-sm"
              @change="query = $event.target.value"
              @blur="query = ''"
              :display-value="(object) => object?.attributes.name"
            />
            <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon class="size-4 text-gray-400" aria-hidden="true" />
            </ComboboxButton>
          </div>
          <ComboboxOptions
            ref="comboboxOptionsRef"
            @scroll="onOptionsScroll"
            class="absolute z-50 max-h-56 w-80 mt-1 overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
            <li
              v-if="!props.physicalPersonOnly"
              @mousedown.prevent.stop
              @click.prevent.stop="addNewCompany()"
              class="relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-indigo-600 hover:text-white"
            >
              <div class="flex items-center">
                <div class="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                  <PlusCircleIcon class="h-4 w-4 text-gray-700"></PlusCircleIcon>
                </div>
                <span class="ml-3 truncate font-medium">
                  {{ $gettext("Nouvelle organisation") }}
                </span>
              </div>
            </li>
            <li
              @mousedown.prevent.stop
              @click.prevent.stop="addNewPhysicalPerson()"
              class="relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-indigo-600 hover:text-white"
            >
              <div class="flex items-center">
                <div class="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                  <PlusCircleIcon class="h-4 w-4 text-gray-700"></PlusCircleIcon>
                </div>
                <span class="ml-3 truncate font-medium">
                  {{ $gettext("Nouvelle personne physique") }}
                </span>
              </div>
            </li>
            <span v-if="filteredCustomers.length > 0">
              <ComboboxOption
                v-for="filteredCustomer in filteredCustomers"
                :key="filteredCustomer.id"
                :value="filteredCustomer"
                as="template"
                v-slot="{ selected }"
              >
                <li
                  @mouseenter="hoveredCustomerId = filteredCustomer.id"
                  @mouseleave="hoveredCustomerId = null"
                  :class="['relative cursor-default select-none py-2 pl-3 pr-9', hoveredCustomerId === filteredCustomer.id ? 'bg-indigo-600 text-white' : 'text-gray-900']">
                  <div class="flex items-center">
                    <div class="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                      <BuildingOfficeIcon v-if="filteredCustomer.type == 'company'" class="h-4 w-4 text-gray-700"></BuildingOfficeIcon>
                      <UserIcon v-if="filteredCustomer.type == 'physicalPerson'" class="h-4 w-4 text-gray-700"></UserIcon>
                    </div>
                    <span :class="['ml-3 truncate', selected && 'font-semibold']">
                      {{ filteredCustomer.attributes.name }}
                    </span>
                  </div>
                </li>
              </ComboboxOption>
            </span>
            <li v-if="customerStore.isFetchingNextPage" class="relative select-none py-2 pl-3 pr-9 text-gray-500 text-center">
              {{ $gettext("Chargement...") }}
            </li>
          </ComboboxOptions>
        </div>
      </div>
      <FormFieldError :field-path="fieldPath" :errors="errors" />
      <div class="flex items-start w-80">
        <ul role="list" class="w-full divide-y divide-gray-100 mt-2 text-sm">
          <li v-for="(selectedCustomer, index) in selectedCustomers" :key="selectedCustomer.id" class="flex justify-between gap-x-6 py-2">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                <BuildingOfficeIcon v-if="selectedCustomer.type == 'company'" class="h-4 w-4 text-gray-700"></BuildingOfficeIcon>
                <UserIcon v-if="selectedCustomer.type == 'physicalPerson'" class="h-4 w-4 text-gray-700"></UserIcon>
              </div>
              <span class="ml-3 truncate font-normal">
                {{ selectedCustomer.attributes.name }}
              </span>
            </div>
            <div class="flex items-center">
              <slot name="actions"
               :customer="selectedCustomer"
               :index="index"/>
            </div>
            <button
              @click.prevent="removeCustomer(selectedCustomer)"
              class="hidden rounded px-2.5 py-1.5 text-sm font-semibold text-red-900 shadow-sm hover:ring-1 ring-red-300 hover:bg-red-50 sm:block">
              <MinusCircleIcon class="text-sm font-semibold text-red-600 size-6"></MinusCircleIcon>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </Combobox>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import { PlusCircleIcon, BuildingOfficeIcon, MinusCircleIcon, UserIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import CompanyForm from "@/components/companies/CompanyForm.vue";
import { useCompanyStore } from "@/stores/company";
import PhysicalPersonForm from "@/components/physical-persons/PhysicalPersonForm.vue";
import { usePhysicalPersonStore } from "@/stores/physicalPerson";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/vue";
import { useCustomerStore } from "@/stores/customer.js";
import FormFieldError from "./FormFieldError.vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  fieldPath: String,
  fieldAttrs: Object,
  fieldLabel: String,
  errors: Object,
  ubo: {
    type: Boolean,
    default: false
  },
  physicalPersonOnly: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["update:modelValue"]);

const customerStore = useCustomerStore();
const query = ref("");
const currentCustomer = ref(null);
const selectedCustomers = ref([]);
const hoveredCustomerId = ref(null);
const companyStore = useCompanyStore();
const company = companyStore.emptyCompany();
const physicalPersonStore = usePhysicalPersonStore();
const physicalPerson = physicalPersonStore.emptyPerson;
const openNewCompanyDrawer = ref(false);
const openNewPhysicalPersonDrawer = ref(false);
const comboboxOptionsRef = ref(null);

const onOptionsScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target;
  const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
  if (distanceFromBottom < 50 && customerStore.hasNextPage && !customerStore.isFetchingNextPage) {
    customerStore.fetchNextPage();
  }
};

const isUBOField = computed(() => {
  return props.ubo && props.ubo === true;
});

const filteredCustomers = computed(() => {
  return customerStore.customers.filter((customer) => {
    const isAlreadySelected = selectedCustomers.value.some(
      (selected) => selected.id === customer.id
    );
    if (isAlreadySelected) return false;
    if (props.physicalPersonOnly && customer.type !== "physicalPerson") {
      return false;
    }
    return true;
  });
});

watch(query, (newQuery) => {
  customerStore.searchQuery = newQuery || null;
});

const selectCustomer = (customer) => {
  if(customer && !selectedCustomers.value.find(selectedCustomer => selectedCustomer.id === customer.id)) {
    selectedCustomers.value.push(customer);
    if (props.ubo && !customer.relationships.ultimateBeneficialOwnerControlType) {
      customer.relationships.ultimateBeneficialOwnerControlType = {
        data: {
          id: null
        }
      };
    }
    emit("update:modelValue", selectedCustomers.value);
    query.value = "";
    currentCustomer.value = null;
  }
};

const removeCustomer = (customer) => {
  selectedCustomers.value = selectedCustomers.value.filter(selectedCustomer => selectedCustomer.id !== customer.id);
  emit("update:modelValue", selectedCustomers.value);
};

watch(
  selectedCustomers,
  (newVal) => {
    emit("update:modelValue", newVal);
  },
  { deep: true }
);

watch(currentCustomer, (customer) => {
  if (customer) {
    selectCustomer(customer);
  }
});

watch(() => props.modelValue, (newModelValue) => {
  if (newModelValue) {
    newModelValue.forEach((selectedCustomer) => {
      selectCustomer(selectedCustomer);
    });
  }
}, { immediate: true });

const addNewCompany = () => {
  toggleNewCompanyDrawer();
};

const addNewPhysicalPerson = () => {
  toggleNewPhysicalPersonDrawer();
};

const onNewCompanySubmit = (payload, actions) => {
  companyStore.saveCompany(payload, (company) => {
    selectCustomer(company);
    toggleNewCompanyDrawer();
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onNewCompanyCancel = () => {
 toggleNewCompanyDrawer();
};

const onPhysicalPersonSubmit = (payload, actions) => {
  physicalPersonStore.savePhysicalPerson(payload, (physicalPerson) => {
    selectCustomer(physicalPerson);
    toggleNewPhysicalPersonDrawer();
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};
const onPhysicalPersonCancel = () => {
  toggleNewPhysicalPersonDrawer();
};

const toggleNewCompanyDrawer = () => {
  openNewCompanyDrawer.value = !openNewCompanyDrawer.value;
};

const toggleNewPhysicalPersonDrawer = () => {
  openNewPhysicalPersonDrawer.value = !openNewPhysicalPersonDrawer.value;
};

// Only request lightweight data for the combobox display (name + type).
// Passing an explicit include list prevents the backend from serializing
// all heavy relationships (SLAs, documents, risk scoring, etc.) which
// would otherwise cause a recursive payload explosion on form submit.
const comboboxIncludes = ["lastRiskScoringLevel"];

onMounted(async () => {
  await customerStore.fetchAll(null, comboboxIncludes);
});

</script>
